const requestReasonOptions = [
  { id: 49, value: 'No disponible' },
  { id: 92, value: 'Decomisado' },
];

export default requestReasonOptions;
